/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef } from 'react';
import { Button, Table, Input, Form, Row, Col, Modal, message, Select, Radio } from 'antd';
import { services } from '@comall-backend-builder/core';
import { navigation } from '@comall-backend-builder/core/lib/services';
import { errorHandle } from '../../services';
import './index.less';
import moment from 'moment';
import { debounce } from 'lodash';
const api = services.api;
const { Option } = Select;
const { TextArea } = Input;

const SknSubstitutionComponent: React.FC<any> = ({ form }) => {
    const [tableData, setTableData] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);
    const [total, setTotal] = useState<any>(0);
    const [pageNum, setPageNum] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(10);
    const [visible, setVisible] = useState<any>(false);
    const [shId, setShId] = useState('');
    const [shStatus, setShStatus] = useState('2');
    const [checkReason, setCheckReason] = useState('');

    useEffect(() => {
        const defaultPage = 1;
        const defaultPageSize = 10;
        try {
            const fromSknSubstitution = sessionStorage.getItem('fromSknSubstitution');
            // 如果是详情页返回
            if (fromSknSubstitution) {
                const SUNBATH_SEARCH = sessionStorage.getItem('CHANGESKU_SEARCH');
                const searchParams = JSON.parse(SUNBATH_SEARCH) || {};
                const { page = defaultPage, per_page = defaultPageSize, ...SEARCH } = searchParams;
                setPageNum(page);
                setPageSize(per_page);
                form.setFieldsValue({
                    ...SEARCH,
                    status: SEARCH.status !== 0 ? SEARCH.status : undefined,
                });
                loadSknList(page, per_page);
            } else {
                loadSknList(defaultPage, defaultPageSize);
            }
        } catch (err) {
            loadSknList(defaultPage, defaultPageSize);
        }
        sessionStorage.setItem('fromSknSubstitution', '');
    }, []);

    const filterUndefined = (obj: any) => {
        const newObj = {};
        Object.keys(obj).forEach((key) => {
            if (obj[key] !== undefined && obj[key] !== '') {
                newObj[key] = obj[key];
            }
        });
        return newObj;
    };

    // 获取数据
    const loadSknList = (page: number, per_page: number) => {
        setLoading(true);
        const searchValue = form.getFieldsValue();
        const params: any = filterUndefined(searchValue);
        if (!params.status) {
            params.status = 0;
        }
        api.get(
            { ...params, page, per_page },
            { apiPath: `/orderReplaceSkn/get_replace_order_list` }
        )
            .then((res: any) => {
                const SEARCH = { ...params, page, per_page };
                sessionStorage.setItem('CHANGESKU_SEARCH', JSON.stringify(SEARCH));
                const { result, totalNum } = res;
                setTableData(result || []);
                setTotal(totalNum);
            })
            .catch(errorHandle)
            .finally(() => {
                setLoading(false);
            });
    };

    const getFields = () => {
        const { getFieldDecorator } = form;
        const children = [
            <Col span={8}>
                <Form.Item label={`置换skn订单编号`} labelCol={{ span: 9 }}>
                    {getFieldDecorator(`replaceOrderNo`)(<Input placeholder="请输入" />)}
                </Form.Item>
            </Col>,
            <Col span={8}>
                <Form.Item label={`销售订单编码`} labelCol={{ span: 9 }}>
                    {getFieldDecorator(`orderNo`)(<Input placeholder="请输入" />)}
                </Form.Item>
            </Col>,
            <Col span={8}>
                <Form.Item label={`状态`} labelCol={{ span: 9 }}>
                    {getFieldDecorator('status')(
                        <Select placeholder="请选择" allowClear>
                            <Option value="1">待审核</Option>
                            <Option value="2">已通过</Option>
                            <Option value="3">已驳回</Option>
                        </Select>
                    )}
                </Form.Item>
            </Col>,
        ];
        return children;
    };

    const handleSearch = (e: React.FormEvent) => {
        e.preventDefault();
        setPageNum(1);
        loadSknList(1, pageSize);
    };

    // 点击重置按钮
    const handleReset = () => {
        form.resetFields();
        setPageNum(1);
        loadSknList(1, pageSize);
    };

    // 查看
    const handleSee = (record: { id: any }) => {
        let path = `/trade/changeSKu/detail/${record.id}`;
        navigation.goto(path);
    };

    // 新增
    const handleEdit = () => {
        let path = `/trade/changeSKu/add`;
        navigation.goto(path);
    };

    const columns: any[] = [
        {
            title: '置换商品订单编号',
            dataIndex: 'replaceOrderNo',
            width: 160,
            ellipsis: true,
            align: 'center',
        },
        {
            title: '销售订单编号',
            dataIndex: 'orderNo',
            width: 160,
            align: 'center',
        },
        {
            title: '创建时间',
            dataIndex: 'createTime',
            width: 160,
            render: (createTime: any) => {
                return createTime ? moment(createTime).format('YYYY-MM-DD HH:mm:ss') : '-';
            },
            align: 'center',
        },
        {
            title: '状态',
            dataIndex: 'status',
            width: 80,
            render: (status: any) => {
                return status == 3 ? (
                    <div className="hide-icon">已驳回</div>
                ) : status == 2 ? (
                    <div className="display-icon">已通过</div>
                ) : (
                    <div>待审核</div>
                );
            },
            align: 'center',
        },
        {
            title: '审核人',
            dataIndex: 'checkUser',
            width: 120,
            align: 'center',
        },
        {
            title: '审核意见',
            dataIndex: 'checkReason',
            width: 180,
            align: 'center',
        },
        {
            title: '审核时间',
            dataIndex: 'updateTime',
            width: 150,
            render: (updateTime: any) => {
                return updateTime ? moment(updateTime).format('YYYY-MM-DD HH:mm:ss') : '';
            },
            align: 'center',
        },
        {
            title: '操作',
            dataIndex: 'action',
            fixed: 'right',
            width: 120,
            align: 'center',
            render: (_: any, record: any) => (
                <>
                    <a type="link" onClick={() => handleSee(record)}>
                        查看
                    </a>
                    {record.status == 1 ? (
                        <a
                            style={{ display: 'inline-block', marginLeft: '12px' }}
                            type="link"
                            onClick={() => {
                                setShId(record.id);
                                setVisible(true);
                            }}
                        >
                            审核
                        </a>
                    ) : null}
                </>
            ),
        },
    ];

    const onShowSizeChange = (_current: any, size: any) => {
        setPageNum(1);
        setPageSize(size);
        loadSknList(1, size);
    };

    // 改变分页
    const handlePageChange = (current: number, size: number) => {
        setPageNum(current);
        setPageSize(size);
        loadSknList(current, size);
    };

    const handleChangSH = (e: any) => {
        setCheckReason(e.target.value);
    };

    // 审核
    const handleCheckReplaceOrder = debounce(() => {
        if (!checkReason) {
            message.warning('审核意见不能为空');
            return;
        }
        setModalLoading(true);
        api.get(
            { orderid: shId, checkReason, status: shStatus },
            { apiPath: `/orderReplaceSkn/check_replace_order` }
        )
            .then((res: any) => {
                if (res.resultCode != 200) {
                    message.error(res.resultMsg);
                } else {
                    message.success('审核成功！');
                }
            })
            .catch(errorHandle)
            .finally(() => {
                setVisible(false);
                setModalLoading(false);
                setTimeout(() => {
                    loadSknList(pageNum, pageSize);
                }, 200);
            });
    }, 500);

    return (
        <div className="sknSubstitution-box">
            <Form
                className="ant-advanced-search-form"
                style={{ marginBottom: '24px' }}
                onSubmit={handleSearch}
            >
                <Row gutter={24}>{getFields()}</Row>
                <Row>
                    <Col span={12}>
                        <Button type="primary" onClick={handleEdit}>
                            新增
                        </Button>
                    </Col>

                    <Col span={12} style={{ textAlign: 'right' }}>
                        <Button type="primary" htmlType="submit">
                            查询
                        </Button>
                        <Button style={{ marginLeft: 8 }} onClick={handleReset}>
                            重置
                        </Button>
                    </Col>
                </Row>
            </Form>
            <Table
                scroll={{ x: 1400 }}
                rowKey="id"
                loading={loading}
                columns={columns}
                dataSource={tableData}
                pagination={{
                    current: pageNum, //当前页码
                    pageSize, // 每页数据条数
                    showSizeChanger: true,
                    showQuickJumper: false,
                    pageSizeOptions: ['10', '15', '20'],
                    total: total,
                    onShowSizeChange: onShowSizeChange,
                    onChange: handlePageChange,
                    showTotal: (total, range) => `第${range[0]}-${range[1]}条/总共${total}条`,
                }}
            />

            <Modal
                width={568}
                centered
                visible={visible}
                title="审核"
                onCancel={() => {
                    setVisible(false);
                }}
                footer={[
                    <Button
                        key="back"
                        onClick={() => {
                            setVisible(false);
                        }}
                    >
                        取消
                    </Button>,
                    <Button
                        key="submit"
                        type="primary"
                        loading={modalLoading}
                        onClick={() => {
                            handleCheckReplaceOrder();
                        }}
                    >
                        确定
                    </Button>,
                ]}
            >
                <div className="sknSubstitution-box-sort">
                    <div className="sort-content">
                        <div className="label">审核结果</div>
                        <div className="value">
                            <Radio.Group
                                value={shStatus}
                                onChange={(e) => setShStatus(e.target.value)}
                            >
                                <Radio value={'2'}>通过</Radio>
                                <Radio value={'3'}>驳回</Radio>
                            </Radio.Group>
                        </div>
                    </div>
                    <div className="sort-content">
                        <div className="label">审核意见</div>
                        <div className="value">
                            <TextArea
                                rows={4}
                                placeholder="输入内容"
                                value={checkReason}
                                onChange={handleChangSH}
                                maxLength={300}
                            />
                            <div className="value-xianzhi">已输入{checkReason.length}/300</div>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export const SknSubstitution = Form.create<any>()(SknSubstitutionComponent);
export default SknSubstitution;
